export default [
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import('@/views/schedule/Schedule.vue'),
  },
  {
    path: '/schedule/show/:id',
    name: 'show-schedule',
    component: () => import('@/views/schedule/control-schedule/ShowSchedule.vue'),
  },
  {
    path: '/schedule/add',
    name: 'add-schedule',
    component: () => import('@/views/schedule/control-schedule/AddEditSchedule.vue'),
  },
  {
    path: '/schedule/edit/:id',
    name: 'edit-schedule',
    component: () => import('@/views/schedule/control-schedule/AddEditSchedule.vue'),
  },
]
